// ✅ Hook: useAssetPurchaseOrderAddForm.ts

import { useMutation } from '@tanstack/react-query';
import * as Yup from 'yup';
// import { addAssetPurchaseOrder } from '@api/services/asset-purchase-order.service';
import { AssetTypeEnum } from '@api/enum';
import { addAssetPurchaseOrder } from '@api/services/asset-purchaase-order.service';

export interface TAssetPurchaseOrderFormValues {
    remarks: string;
    typeOfAssets?: AssetTypeEnum | null;
    quantity: number | string;
    files: File[];
}

export const useAssetPurchaseOrderAddForm = (clientInstallationId: string, projectInstallationId: string) => {
    const schema = Yup.object({
        remarks: Yup.string().required('Remarks are required'),
        typeOfAssets: Yup.mixed<AssetTypeEnum>()
            .oneOf([...Object.values(AssetTypeEnum), null])
            .nullable(),
        files: Yup.array().of(Yup.mixed()),
    });

    const initialValues: TAssetPurchaseOrderFormValues = {
        remarks: '',
        typeOfAssets: null,
        quantity: 0,
        files: [],
    };

    const mutation = useMutation((formData: FormData) =>
        addAssetPurchaseOrder(clientInstallationId, projectInstallationId, formData)
    );

    const submit = async (values: TAssetPurchaseOrderFormValues) => {
        const formData = new FormData();
        formData.append('remarks', values.remarks);
        if (values.quantity) {
            formData.append('quantity', values.quantity.toString());
        }
        if (values.typeOfAssets) {
            formData.append('typeOfAssets', values.typeOfAssets);
        }
        values.files.forEach((file) => formData.append('files', file));

        const { data } = await mutation.mutateAsync(formData);
        return data;
    };

    return {
        initialValues,
        schema,
        isSubmitting: mutation.isLoading,
        submit,
    };
};
